import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { IFile } from "../file.interface";
import { FileService } from "../file.service";
import { FileUploadValidators } from '@iplab/ngx-file-upload';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css'],
})
export class FileUploaderComponent implements OnInit, OnChanges {
  @Input() fileLimit: number = 1;
  @Input() fileAccept: string = '*';
  @Input() files = [];

  @Output() uploading: EventEmitter<void> = new EventEmitter<void>();
  @Output() updated: EventEmitter<void> = new EventEmitter<void>();

  // form: UntypedFormGroup;
  subscriptions: Subscription;

  private filesControl = new FormControl<File[]>([]);
  public form: UntypedFormGroup = new FormGroup({
    files: this.filesControl
  });

  constructor(
    public formBuilder: UntypedFormBuilder,
    public _FileService: FileService
  ) {
    this.subscriptions = new Subscription();
  }

  /* REFACTOR ***********************************/
  /* improve response */
  ngOnChanges(data: SimpleChanges) {
    console.log('ngOnchanges');

    if (data["files"].currentValue && data["files"].currentValue.length > 0) {
      this.form.controls["files"].setValue(data["files"].currentValue.map((el: IFile) => {
        return {
          _id: el,
          link: el.fileUrl,
          preview: el.fileUrl
        }
      }));
    }
  }
  /* REFACTOR ***********************************/

  ngOnInit() {
    console.log('ngOnInit');

    this.subscriptions.add(this.form.valueChanges.subscribe(event => this.onChange(event)));
  }

  async onChange(event: any) {
    console.log('onChange', event);

    this.uploading.emit();

    const filesToUpload: any[] = event.files.filter((file: any) => !file._id);

    for (const file of filesToUpload) {
      const formData = new FormData();
      formData.append('file', file);

      let uploaded = await this._FileService.uploadFile(formData);
      file._id = uploaded._id;
    }

    this.updated.emit(event);
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy');

    this.subscriptions.unsubscribe();
  }
}